import { Modal, Typography, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { pageUrl } from '@/constants/url'
/// <reference types="vite-plugin-svgr/client" />
import ReactLogo from '@/assets/illustrations/timeout.svg?react'
import { useUserStore } from '@/store/useUserStore'
import { AppModal } from '../commons/appModal/appDrawer'
const { Paragraph, Title } = Typography
export const ModalExpired = () => {
  const { sessionTimeout } = useUserStore()
  const navigate = useNavigate()
  const handleClearSession = () => {
    navigate(pageUrl.signIn)
  }
  return (
    <AppModal zIndex={999} open={sessionTimeout} closable={false} footer={null}>
      <div className="flex justify-center">
        <ReactLogo className="h-[200px] text-pallet3" width="200px" />
      </div>
      <Title level={4} className="mt-0 text-center">
        Your session expired
      </Title>
      <Paragraph className="text-center" type="secondary">
        You need to relogin for continue your activities
      </Paragraph>
      <Button onClick={handleClearSession} type="primary" block>
        Back to login
      </Button>
    </AppModal>
  )
}
